<template>
  <div
    data-test-id="LdapList"
  >
    <HeadingExtraSmall
      data-test-id="LdapList__ldapHeading"
      :hasMargin="false"
    >
      {{ $options.ldapConfig.label }}
    </HeadingExtraSmall>
    <LoadingIcon
      v-if="isLoading"
      :scale="1.75"
    />
    <ResourceError
      v-else-if="hasError"
      data-test-id="LdapList__ldapError"
    />
    <ParagraphBody
      v-else
      data-test-id="LdapList__ldapList"
    >
      {{ getLdapName }}
      <Link
        v-if="showLearnMoreLink"
        data-test-id="LdapList__ldapLearnMoreLink"
        :href="$options.ldapConfig.href"
        isExternal
        target="_blank"
        :text="$options.ldapConfig.linkText"
      />
    </ParagraphBody>
  </div>
</template>

<script>
import {
  HeadingExtraSmall,
  Link,
  LoadingIcon,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import ItemType from 'client/util/Constants/ItemType';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import ResourceError from 'client/systemusers/UserDetails/UserResources/ResourceError.vue';

const { LdapItemType } = ItemType;
const ldapItem = new LdapItemType();

const directoryCollection = 'DirectoryCollection';
const systemUserModel = 'SystemUserModel';

export default {
  name: 'LdapList',

  components: {
    Link,
    LoadingIcon,
    HeadingExtraSmall,
    ParagraphBody,
    ResourceError,
  },

  data: () => ({
    hasError: false,
    isLoading: true,
    serverName: '',
  }),

  ldapConfig: {
    href: KbArticleUrls.LdapKB,
    label: ldapItem.title,
    linkText: 'Learn more',
    zeroStateText: `${ldapItem.title} has not been assigned to this user.`,
  },

  computed: {
    ...mapGetters(directoryCollection, ['getLdap']),

    getLdapName() {
      return this.serverName || this.$options.ldapConfig.zeroStateText;
    },

    showLearnMoreLink() {
      return this.serverName === '';
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(directoryCollection, ['fetchCollection']),
    ...mapActions(systemUserModel, ['fetchLdapAssociation']),

    async getLdapAssociation() {
      const ldap = this.getLdap;
      const ldapId = get(ldap, 'id');

      const { found, errorOccurred } = await this.fetchLdapAssociation(ldapId);

      if (found) {
        this.serverName = ldap.name;
      }
      this.hasError = errorOccurred;
    },

    async handleMounted() {
      await this.fetchCollection();
      await this.getLdapAssociation();
      this.isLoading = false;
    },
  },
};
</script>

<style scoped module>
.linkText.linkText {
  text-transform: none;
}
</style>
